import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, Input, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { IMainMenuDropdown } from '@app-store';
import { AuthStore } from '@pages/auth/auth-store';
import { IMenuItemLink } from '@utils/interfaces/menu-item-link.model';
import { APP } from 'src/app/app.constant';

import { DisplayWithAuthPipe } from '../pipes/display-with-auth.pipe';
import { SubMenuComponent } from '../sub-menu/sub-menu.component';
import { NavigateToUrlDirective } from '@core/directive/navigate-to-url/navigate-to-url.directive';

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [CommonModule, RouterModule, DisplayWithAuthPipe, SubMenuComponent, NavigateToUrlDirective]
})
export class MainMenuComponent implements OnInit {
  @Input()
  menuItems: (IMainMenuDropdown & IMenuItemLink)[];

  // Computed properties for better performance
  readonly authInfor = computed(() => this.authStore.authInfo());

  private readonly authStore = inject(AuthStore);

  constructor(private readonly router: Router) {}

  ngOnInit(): void {}

  login(): void {
    this.router.navigateByUrl(APP.LOGIN_URL);
  }

  logout(): void {
    this.authStore.logout();
  }
}
